import Vue from 'vue'
import VueRouter from 'vue-router'
import Dispatch from '../components/CaseDispatch.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dispatch',
    component: Dispatch
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: () => import('../components/CaseMonitor.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
